import React, { useState, useEffect } from "react";
import { Box, Typography, TextField } from "@mui/material";
import {
  cardOutline,
  semiBoldFonts,
  textFieldStyles,
} from "../../../Styles/Styles";

const PriceFilter = ({ onFilterChange, defaultFilters }) => {
  const [minPrice, setMinPrice] = useState(
    defaultFilters.priceRange?.[0] || ""
  );
  const [maxPrice, setMaxPrice] = useState(
    defaultFilters.priceRange?.[1] || ""
  );

  // Update state when filters change externally
  useEffect(() => {
    setMinPrice(defaultFilters.priceRange?.[0] || "");
    setMaxPrice(defaultFilters.priceRange?.[1] || "");
  }, [defaultFilters]);

  const handleMinPriceChange = (e) => {
    const value = e.target.value
      ? Math.max(0, parseInt(e.target.value, 10))
      : "";
    setMinPrice(value);
    onFilterChange({ priceRange: [value, maxPrice] });
  };

  const handleMaxPriceChange = (e) => {
    const value = e.target.value
      ? Math.max(0, parseInt(e.target.value, 10))
      : "";
    setMaxPrice(value);
    onFilterChange({ priceRange: [minPrice, value] });
  };

  return (
    <Box
      sx={{
        p: 2,
        mb: 2,
        borderRadius: "8px",
        ...cardOutline,
      }}
    >
      <Typography variant="h6" gutterBottom sx={{ mb: 2, ...semiBoldFonts }}>
        Price
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <TextField
          label="Min Price"
          type="number"
          value={minPrice}
          onChange={handleMinPriceChange}
          variant="outlined"
          inputProps={{ min: 0 }}
          sx={{ ...textFieldStyles }}
        />
        <TextField
          label="Max Price"
          type="number"
          value={maxPrice}
          onChange={handleMaxPriceChange}
          variant="outlined"
          inputProps={{ min: 0 }}
          sx={{ ...textFieldStyles }}
        />
      </Box>
    </Box>
  );
};

export default PriceFilter;
